import React from 'react';

interface LastNameFieldProps {
  id: string;
  name: string;
  label: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  disabled?: boolean;
  className?: string;
}

const LastNameField: React.FC<LastNameFieldProps> = ({
  id,
  name,
  label,
  placeholder,
  value,
  onChange,
  autoComplete,
  disabled = false,
  className = '',
}) => {
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-700 dark:text-gray-300"
      >
        {label}
      </label>
      <div className="mt-1">
        <input
          id={id}
          name={name}
          type="text"
          autoComplete={autoComplete}
          value={value}
          onChange={onChange}
          className="appearance-none block w-full px-3 py-2 border rounded-md placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none sm:text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border-gray-300 dark:border-gray-600 focus:ring-blue-500 focus:border-blue-500"
          placeholder={placeholder}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default LastNameField;
